import request from '@/utils/request'

export async function getData(data) {
  return request({
    url: '/personApplications/list',
    method: 'post',
    data,
  })
}
export async function getDetail(data) {
  return request({
    url: '/personApplications/detail',
    method: 'get',
    params: data,
  })
}
export async function searchData(data) {
  return request({
    url: '/personApplications/get',
    method: 'post',
    data,
  })
}
export async function createData(data) {
  return request({
    url: '/personApplications/save',
    method: 'post',
    data,
  })
}
export async function updateData(data) {
  return request({
    url: '/personApplications/edit',
    method: 'post',
    data,
  })
}
export async function deleteData(data) {
  return request({
    url: '/personApplications/delete',
    method: 'post',
    data,
  })
}
export async function pushData(data) {
  return request({
    url: '/personApplications/push',
    method: 'post',
    data,
  })
}
export async function revoke(data) {
  return request({
    url: '/personApplications/revoke',
    method: 'post',
    data,
  })
}
export async function approvalProcess(data) {
  return request({
    url: '/v2/personApplications/check/process/info',
    method: 'post',
    data,
  })
}
